import Vue from 'vue';
import { ValidationProvider, ValidationObserver, extend, localize } from "vee-validate";
import { required, email } from "vee-validate/dist/rules";
import id from '@/locales/id.json';
import en from '@/locales/en.json';

extend("required", required);

extend("email", email);

extend("phone_number", (value) => {
  // regex based on function in embed-form/src/components/Form/index.vue#validate
  const regex = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{1,3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/ 
  
  if (regex.test(value)) {
    return true;
  }

  return 'Masukkan nomor WA dengan valid (minimal 10 digit)'
});

extend("url", (value) => {
  // regex based on function in embed-form/src/components/Form/index.vue#validate
  var regex = new RegExp(
    "^(https?:\\/\\/)?" + // protocol
    "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|" + // domain name
    "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
    "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
    "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
    "(\\#[-a-z\\d_]*)?$",
    "i"
  );
  
  if (regex.test(value)) {
    return true;
  }

  return 'Masukkan url yang valid'
});

// Register localization validation messages
localize({
  en: en.veevalidate,
  id: id.veevalidate,
})

// Set default to id
localize('id');

// Register it globally
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);